module.exports = __webpack_public_path__ + "static/chantal-2ce655daf9a893abb1681531ea68cf9e.svg";